import { Component, computed, effect, inject, input } from '@angular/core';
import { DocumentPreview } from '../../components/document-preview/document-preview';
import { LoadingSpinner, Button } from 'excellence-ui';
import { ErrorPage } from '../../../../shared/components/error-page/error-page';
import { DocumentsStore } from '../../stores/documents.store';
import { DocumentPreviewHeader } from '../../components/document-preview-header/document-preview-header';
import { RouterLink } from '@angular/router';
import { NgIcon } from '@ng-icons/core';

@Component({
  selector: 'app-documents-preview-page',
  templateUrl: './documents-preview-page.html',
  imports: [
    DocumentPreview,
    LoadingSpinner,
    ErrorPage,
    DocumentPreviewHeader,
    RouterLink,
    Button,
    NgIcon,
  ],
})
export class DocumentsPreviewPage {
  private documentsStore = inject(DocumentsStore);

  organizationId = input.required<string>();
  documentId = input.required<string>();

  protected document = computed(() => this.documentsStore.allDocuments()[this.documentId()]);

  constructor() {
    effect(() => {
      const documentId = this.documentId();
      const document = this.document();
      if (!document && documentId) {
        this.documentsStore.loadSingle(documentId);
      }
    });
  }
}
